import { FaCaretDown, FaCaretUp, FaMinus, FaPlus } from "react-icons/fa";
import CustomBox from "../CustomBox";
import { useEffect, useState } from "react";
import { Colors, FATIA_PIZZA } from "../../config";

interface IProdKit {
  chave: number;
  descricao: string;
  observacao?: string;
  preco_venda: string;
  qme: number;
}

interface IGrupoKit {
  descricao: string;
  descricao_web?: string;
  produtosnv1: IProdKit[];
}

interface Iadicional {
  chave: number;
  quantidade: string;
  custo: string;
  ordem: number;
  grupo_kit: IGrupoKit;
  quantidadeSabores: number;
  quantidadeMaxima: number;
  obg: number;
  index: number;
  extras: any[];
  onAdd: Function;
  onMinus: Function;
  onPlus: Function;
}

export default function RenderListAdicionais(props: Iadicional) {
  const [open, setOpen] = useState(false);
  const [parametros, setParametros] = useState({
    limite: 0,
    quantidade: 0,
  });
  const id = `containerList${props.index}`;

  const RenderQuantityItem = (prod: IProdKit) => {
    const prod_extras = props.extras;
    if (prod_extras?.filter((e) => e?.chave === prod?.chave)[0]) {
      const prod2 = prod_extras?.filter((e) => e?.chave === prod?.chave)[0];
      if (prod2) {
        return prod2.quantidade;
      }
      return 0;
    }
    return 0;
  };

  useEffect(() => {
    if (props.ordem === 99) {
      setOpen(false);
    } else {
      setOpen(true);
    }
    if (props.obg === 1) {
      setOpen(true);
    }
    if (props?.grupo_kit?.produtosnv1[0]) {
      if (FATIA_PIZZA) {
        setParametros({
          quantidade: parametros.quantidade,
          limite: props.quantidadeSabores,
        });
      } else {
        setParametros({
          quantidade: parametros.quantidade,
          limite:
            parseFloat(`${props?.grupo_kit?.produtosnv1[0]?.qme || 0}`) || 0,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (FATIA_PIZZA) {
      console.log(parametros.quantidade, props.quantidadeSabores, "teste");
      setParametros({
        quantidade: parametros.quantidade,
        limite: props.quantidadeSabores,
      });
    }
  }, [props.quantidadeSabores]);

  useEffect(() => {
    const quantidade = props?.extras
      ?.filter((e) => e?.chave_kit === props?.chave)
      ?.reduce((a, b) => {
        return a + b?.quantidade;
      }, 0);
    if (props?.extras[0]) {
      const quantidade = props?.extras
        ?.filter((e) => e?.chave_kit === props?.chave)
        ?.reduce((a, b) => {
          return a + b?.quantidade;
        }, 0);
      if (FATIA_PIZZA) {
        setParametros({
          quantidade: quantidade,
          limite: props.quantidadeSabores,
        });
      } else {
        setParametros({
          quantidade: quantidade,
          limite: parametros.limite,
        });
      }
    } else if (props?.grupo_kit?.produtosnv1[0]) {
      if (FATIA_PIZZA) {
        setParametros({
          quantidade: quantidade,
          limite: props.quantidadeSabores,
        });
      } else {
        setParametros({
          quantidade: quantidade,
          limite:
            parseFloat(`${props?.grupo_kit?.produtosnv1[0]?.qme || 0}`) || 0,
        });
      }
    }
  }, [props.extras]);

  return (
    <div
      key={props?.chave}
      id={id}
      style={
        !open
          ? {
              marginTop: 10,
              marginBottom: 10,
            }
          : {}
      }
    >
      <span
        id="title_kit"
        style={{
          backgroundColor: Colors.listGroupBackground,
          borderColor: Colors.listGroupBorderColor,
        }}
        onClick={() => setOpen(!open)}
      >
        <div
          style={{
            width: "100%",
            flexDirection: "column",
            justifyContent: "space-between",
            display: "flex",
          }}
        >
          <span style={{ color: Colors.listGroupTitleColor }}>
            {" "}
            {props?.grupo_kit?.descricao || ""}
          </span>

          {props?.grupo_kit?.descricao_web && (
            <span
              style={{
                fontSize: 12,
                color: Colors.modalDetailColor,
                marginLeft: 15,
                marginTop: 2,
                marginBottom: 2,
              }}
            >
              {props?.grupo_kit?.descricao_web}
            </span>
          )}
        </div>

        {props.ordem === 99 && !open && (
          <FaCaretDown
            style={{ marginRight: 20, color: "aqua", paddingBottom: 2 }}
            size={20}
          />
        )}
        {props.ordem === 99 && open && (
          <FaCaretUp
            style={{ marginRight: 20, color: "aqua", paddingBottom: 2 }}
            size={20}
          />
        )}

        <span
          style={{
            position: "absolute",
            right: "48px",
            fontSize: 12,
            color: "red",
          }}
        >
          {props?.obg === 1 ? " Obrigatorio" : ""}{" "}
        </span>

        <span
          style={{
            position: "absolute",
            right: props?.obg === 1 ? "120px" : "48px",
            fontSize: 15,
            color: Colors.modalDetailColor,
          }}
        >
          {`${parametros.quantidade} de ${parametros.limite}`}
        </span>
      </span>

      <div id="containerOpcoes" data-height={open ? "a" : "b"}>
      {props?.grupo_kit?.produtosnv1?.map((e, i) => {
          let valor_novo = parseFloat(e.preco_venda);
          if (FATIA_PIZZA) {
            valor_novo =
              valor_novo * (props.quantidadeMaxima / props.quantidadeSabores);
          }
          return (
            <div
              style={props?.ordem === 90 ? {} : { cursor: "auto" }}
              onClick={() =>
                props?.ordem === 90
                  ? props.onAdd(e, props?.ordem, props?.chave)
                  : {}
              }
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  color: Colors.listGroupTitleColor,
                }}
              >
                <label
                  htmlFor={`${e.descricao}${i}`}
                  style={{ fontSize: "0.8em", paddingLeft: 10 }}
                >
                  {e?.descricao}
                </label>
                {parseFloat(e.preco_venda) > 0 && props.ordem == 99 && (
                  <span style={{ fontSize: "0.70em" }}>
                    {" "}
                    + R$
                    {new Intl.NumberFormat("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(valor_novo)}
                  </span>
                )}
                <span
                  style={{
                    fontSize: "0.6em",
                    paddingLeft: 10,
                    color: Colors.modalDetailColor,
                    marginTop: 3,
                  }}
                >
                  {" "}
                  {e?.observacao}
                </span>
              </div>
              {props?.ordem === 90 && (
                <CustomBox
                  items={props.extras}
                  chave={e.chave}
                  color={"white"}
                  size={25}
                  background={"rgb(41, 27, 27)"}
                  border_color={"rgb(41, 27, 27)"}
                />
              )}
              {props?.ordem === 99 && (
                <div
                  style={{
                    height: 40,
                    width: "30%",
                    borderRadius: 5,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "40%",
                    }}
                    onClick={() => props.onMinus(e, props?.ordem, props?.chave)}
                  >
                    <FaMinus size={12} color={Colors.listGroupTitleColor} />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: Colors.listGroupTitleColor,
                      width: "20%",
                    }}
                  >
                    {
                      RenderQuantityItem(e) // colocar uma funcao para puxar a quantidade dos items geral
                    }
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "40%",
                    }}
                    onClick={() => props.onPlus(e, props?.ordem, props?.chave)}
                  >
                    <FaPlus size={12} color={Colors.listGroupTitleColor} />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
